import React, { useState, useEffect } from "react";
import './images-media.css';
import {
    Button,
    Form,
    Col,
    Row,
    Container,
    Image,
    Modal,
  } from "react-bootstrap";
import Cropper from 'react-easy-crop'
import {useForm} from "react-hook-form";
import axios from 'axios';
// import { useHistory } from "react-router-dom";
import { Storage } from '../../../firebase/index';
import SyncLoader from "react-spinners/SyncLoader";
import GenericModal from '../../generic/modal';
import Message from './message'
import getCroppedImg from './crop-image';
import { uuid } from 'uuidv4';

// import { styles } from './styles'
import ReactGA from 'react-ga';

export default function ImagesMedia(props) {
  ReactGA.pageview(window.location.pathname + window.location.search);    
  const clinicData = props.location.state.clinicData;
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [success, setSuccess] = useState(Boolean);
  const [imageURL, setImageURL] = useState('');
  const [logoURL, setLogoURL] = useState('');
  const {register, handleSubmit} = useForm();

  const [cropShape, setCropShape] = useState('rect');
  const [aspect, setAspect] = useState(1);
  const [imageSrc, setImageSrc] = useState(null);

  const [crop, setCrop] = useState({ x: 0, y: 0 })
  const [zoom, setZoom] = useState(1)
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null)

  const [croppedImage, setCroppedImage] = useState(null)
  const [croppedLogo, setCroppedLogo] = useState(null)

  const [showCropModal, setShowCropModal] = useState(false);

  const handleClose = () => setShowCropModal(false);

  const noImage = "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/No_image_available.svg/600px-No_image_available.svg.png";
  const token = localStorage.getItem('token');
  const axiosConfig = {
      headers: {
          Authorization: token
    }
  };

  useEffect(() => {
    if (clinicData.image_urls && clinicData.image_urls.length > 4){
      setImageURL(clinicData.image_urls);
    } else {
      setImageURL (noImage)
    }
    if (clinicData.logo_url && clinicData.logo_url.length > 4){
      setLogoURL(clinicData.logo_url);
    } else {
      setLogoURL (noImage)
    }
    // eslint-disable-next-line
  }, []);

  const startCroping = async (image, shape) => {
    setCropShape(shape);
    let imageDataUrl = await readFile(image);
    setImageSrc(imageDataUrl);
    setShowCropModal(true);
  }

  function readFile(file) {
    return new Promise(resolve => {
      const reader = new FileReader()
      reader.addEventListener('load', () => resolve(reader.result), false)
      reader.readAsDataURL(file)
    })
  }

  const onCropComplete = (croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }
  
  const cropImage = async () => {
    const cropImg = await getCroppedImg(imageSrc, croppedAreaPixels)
    if(cropShape === 'round'){
      setAspect(1)
      setCroppedLogo(cropImg);
    } else {
      setAspect(4/3);
      setCroppedImage(cropImg);
    }
    handleClose();
  }


  const onSubmit = async (data) => {
    console.log(data);
    setLoading(true);
    data._id = props.location.state.clinicData._id;
    let result = await uploadToFirebase(data);
    axios.post('https://uae-dentist-backend.herokuapp.com/account/clinic-profile', result, axiosConfig)
    .then(function (response) {
        console.log(response)
        setLoading(false);
        setSuccess(true);
        setShow(true);
    })
    .catch(function (error) {
      setSuccess(false);
      setShow(true);
      setLoading(false);
      console.log(error);
    })  

    .catch(function (error) {
      setLoading(false);
      console.log(error);
    });

  }

  const uploadToFirebase = async (data) => { 
    let newLogo = await uploadImage(croppedLogo);
    let newImage = await uploadImage(croppedImage);
    delete data.logo;
    delete data.image;
    if (logoURL === noImage && !newLogo){
      deleteLogo();
    }
    if (imageURL === noImage && !newImage){
      deleteImage();
    }
    if(newLogo){
      data.logo_url = newLogo;
      setLogoURL (newLogo);
    }
    if(newImage){
      data.image_urls = newImage;
      setImageURL (newImage);
    }
    return data;
  }

  const uploadImage = async (image) => { 
    if(!image){
      return (null);
    }
    return new Promise(resolve => { 
      const uploadTask = Storage.ref(`clinics/${uuid()}`).put(image);
      uploadTask.on('state_changed', function(snapshot){
        let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log('Upload is ' + progress + '% done');
      }, function(error) {
        // Handle unsuccessful uploads
      }, function() {
        uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
          console.log('File available at', downloadURL);
          resolve(downloadURL);
        });
      });
    })
  }

  ////////////////////////////////////////////////////

  const clickedDeleteLogo  = async () => { 
    setLoading(true)
    deleteLogo();
    const data = {_id: clinicData._id, logo_url:''}
    postData(data);
  }

  const clickedDeleteImage = async () => { 
    setLoading(true)
    deleteImage();
    const data = {_id: clinicData._id, image_urls:''}
    postData(data);
  }

  const deleteLogo = async () => { 
    console.log(logoURL)
    let name = logoURL.substr(logoURL.indexOf('%2F') + 3, (logoURL.indexOf('?')) - (logoURL.indexOf('%2F') + 3));
    name = name.replace('%20',' '); 
    let storagePath = Storage.ref();
    storagePath.child(`clinics/${name}`).delete()
    setLogoURL(noImage)
  }

  const deleteImage = async () => { 
    console.log(imageURL)
    let name = imageURL.substr(imageURL.indexOf('%2F') + 3, (imageURL.indexOf('?')) - (imageURL.indexOf('%2F') + 3));
    name = name.replace('%20',' '); 
    let storagePath = Storage.ref();
    storagePath.child(`clinics/${name}`).delete()
    setImageURL(noImage)
  }

  //////////////////////////////////////////////////////////

  const postData = async (data) => { 
    console.log(data)
    axios.post('https://uae-dentist-backend.herokuapp.com/account/clinic-profile', data, axiosConfig)
    .then(function (response) {
        console.log(response)
        setLoading(false);
        setSuccess(true);
        setShow(true);
    })
    .catch(function (error) {
      console.log(error);
      setSuccess(false);
      setShow(true);
      setLoading(false);
    })
  }

    return (
    <Container className="mt-5 rounded">
    { show && <GenericModal setShow={setShow} show={show} success={success}/>}
      <Row>
        <Col id="message" sm={12} md={6} lg={6} className="rounded p-5 mt-2 mb-2">
          <Message/>
        </Col>

        <Col id="form" sm={12} md={6} lg={4}className="p-4 rounded">
          <Form onSubmit={handleSubmit(onSubmit)}>

            <Image className="my-1" src={`${logoURL}`} roundedCircle thumbnail />  
                        
            <Row>
            <Form.Group controlId="logo">
              <Form.File onChange={(event) => startCroping(event.target.files[0], 'round') } name="logo" accept=".jpg,.gif,.png" label="Upload your Logo" ref={register ()}/>
            </Form.Group>

            </Row>
            <Image className="my-1" src={`${imageURL}`} rounded thumbnail  />  
            <Form.Group controlId="image">
              <Form.File onChange={(event) => startCroping(event.target.files[0], 'rect')} name="image" accept=".jpg,.gif,.png" label="Upload images of your Clinic" ref={register ()}/>
            </Form.Group>


            <Button variant="primary" type="submit">
                Upload images
            </Button>
            { logoURL !== noImage &&
              <Button className='mx-1' variant="danger" onClick={clickedDeleteLogo}>
                  Remove Logo
              </Button>
            }
            { imageURL !== noImage &&
              <Button className='mx-1' variant="danger" onClick={clickedDeleteImage}>
                  Remove Image
              </Button>
            }


            <div className='mt-5'>
              <SyncLoader
                size={15}
                margin={2}
                color={"#123abc"}
                loading={loading}
              />
            </div>

          </Form>
    
        </Col>
      </Row>

        <Modal size="lg" show={showCropModal} onHide={handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>Crop Image</Modal.Title>
            </Modal.Header>
              <Modal.Body className="scale">
              <Cropper
                cropShape={cropShape}
                image={imageSrc}
                crop={crop}
                zoom={zoom}
                aspect={aspect}
                onCropChange={setCrop}
                onCropComplete={onCropComplete}
                showGrid={false}
                // onCropComplete={() =>console.log('stopped')}
                onZoomChange={setZoom}
              />
              </Modal.Body>
              <Form>
              <Form.Group className='text-center' controlId="formBasicRange">
                <Form.Label>Zoom</Form.Label>
                <Form.Control 
                
                value={zoom}
                min={1}
                max={3}
                step={0.1}
                onChange={(e) => setZoom(e.target.value)}
                type="range" 
                custom 
                />
              </Form.Group>
              <Modal.Footer>
              <Button variant="primary" onClick={()=>cropImage()}>
                Crop
              </Button>
              <Button variant="danger" onClick={handleClose}>
                Close
              </Button>
            </Modal.Footer>
            </Form>
          </Modal>
    </Container>
    )
}


